import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

const SUPPORTED_LANGS = ['zh', 'en', 'ja', 'ko', 'th', 'vi', 'es'];

/**
 * 動態載入單一語系檔（Vite 會為每個語系建立獨立 chunk）
 */
function loadLocale(lang) {
  switch (lang) {
    case 'en': return import('./locales/en/index.js');
    case 'es': return import('./locales/es/index.js');
    case 'ja': return import('./locales/ja/index.js');
    case 'ko': return import('./locales/ko/index.js');
    case 'th': return import('./locales/th/index.js');
    case 'vi': return import('./locales/vi/index.js');
    case 'zh':
    default:   return import('./locales/zh/index.js');
  }
}

/**
 * 初始化 i18n — 只載入當前語系，其餘語系在切換時才載入
 */
export async function initI18n() {
  const stored = localStorage.getItem('gowarehouse_language');
  const detected = stored || new Intl.Locale(navigator.language).language || 'zh';
  const lang = SUPPORTED_LANGS.includes(detected) ? detected : 'zh';

  const locale = await loadLocale(lang);
  const resources = { [lang]: locale.default };

  await i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      lng: lang,
      fallbackLng: 'zh',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'gowarehouse_language',
        caches: ['localStorage'],
      },
    });

  // 攔截語系切換：載入新語系後再切換
  const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
  i18n.changeLanguage = async (lng, callback) => {
    if (!i18n.hasResourceBundle(lng, 'translation')) {
      const locale = await loadLocale(lng);
      i18n.addResourceBundle(lng, 'translation', locale.default.translation, true, true);
    }
    return originalChangeLanguage(lng, callback);
  };

  // Expose for debugging
  window.i18n = i18n;

  return i18n;
}

export default i18n;
